import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { updateNotificationReadApi } from "../../apis";
import { AppContext } from "../../appContext";

function MessageCard({
  message,
  scanMessage,
  time,
  fromDate,
  data,
  viewFunction,
  setcurrentdata,
  notificationfun,
}) {
   const { getnotificaitondata } = useContext(AppContext);
   const [profilePicUrl, setProfilePicUrl] = useState();
   const [profileName, setProfileName] = useState();
    const navigate = useNavigate();

  const handleClick = () => {
    console.log(data?.type);
    updateread();
    if (data.type == 'ReferredMilestoneReward' || data.type == 'ReferralMilestoneReward') {
      navigate('/referralhistory', { state: { type: data.type } });
    } else if (data?.type == 'ConsultationCompleted') {
      viewFunction({id:data?.ConsultationId, type:data?.type});
    } else if (data?.type == 'socketmessage') {
      viewFunction({id:data?.ConsultationId, type:data?.type});
    } else {
      viewFunction({id:data?.ConsultationId, type:data?.type});
    }
  };
  // console.log(data);
  //  console.log(data);
  useEffect(() => {
    console.log("consultation id", data?.ConsultationId);
    setcurrentdata(data?.ConsultationId);
  }, [data]);
  function getInitials(name) {
    if (!name) {
      return null;
    }

    const nameArray = name.split(" ");
    return nameArray
      .map((word) => word.slice(0, 2))
      .join("")
      .toUpperCase();
  }

  function getBackgroundColor(name) {
    // Generate a background color based on the hash of the name
    const hashCode = name
      .split("")
      .reduce((acc, char) => char.charCodeAt(0) + acc, 0);
    const colors = ["#f6ad55", "#f687b3", "#68d391", "#63b3ed", "#a0aec0"];
    return colors[hashCode % colors.length];
  }

  function Avatar({ name }) {
    const initials = getInitials(name);
    const bgColor = getBackgroundColor(name);

    return (
      <div
        className="w-10 h-10 min-w-10 rounded-full flex justify-center items-center"
        style={{ backgroundColor: bgColor }}
      >
        <span className="text-white font-semibold text-xs">{initials}</span>
      </div>
    );
  }
  const updateread = async () => {
    try {
      const res = await updateNotificationReadApi({
        _id: data?._id,
        isRead: true,
      });
      if (res.status === 200) {
        console.log(res.data);
        notificationfun();
        getnotificaitondata()
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if(data){
      if(data?.type == 'ConsultationCompleted' || data?.type == 'socketmessage'){
        setProfilePicUrl(data?.hospitalDetails?.profilePic);
        setProfileName(data?.hospitalDetails?.hospitalName);
      } else {
        setProfilePicUrl(data?.doctorDetails?.coverPic);
        setProfileName(data?.doctorDetails?.DoctorName);        
      }
    }
  }, [data]);

  return (
    <div className="messageDiv p-3 border-b border-gray-200 bg-white cursor-pointer">
      <div
        className="flex items-center gap-4 relative"
      onClick={handleClick}
      >
        {profilePicUrl && profilePicUrl !== "" ? (
          <img
            src={`${process.env.REACT_APP_API_URL}/${profilePicUrl}`}
            className="size-10 min-w-10 rounded-full bg-gray-200 object-cover"
          />
        ) : (
          <Avatar name={profileName || 'User'} />
        )}
        <div className="space-y-1">
          <p className="baseText text-coalBlack capitalize">{data?.message}</p>
          {/* <div
            className={`gap-2 ${scanMessage != '' ? 'inline-flex' : 'hidden'}`}
          >
            <FaFileMedical className="text-base text-red-500 mt-0.5" />
            <p className="text-sm font-medium text-coalBlack">scan mesage</p>
          </div> */}
          {/* <FromDateNotification fromDate={fromDate} time={time} /> */}
        </div>
        {!data?.isRead && (
          <div className="w-3 h-3 rounded-full bg-blue-300 border-2 border-blue-600 absolute -top-2 -left-2"></div>
        )}
      </div>
    </div>
  );
}

function FromDateNotification({ fromDate, time }) {
  return (
    <p className="text-sm text-gray-300 font-normal">
      <span className="capitalize">{fromDate}</span> at {time}{" "}
    </p>
  );
}

export default MessageCard;
